import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import LineEdit from '@app/pages/customer/LineEdit/LineEdit.tsx';

const EditLinePage: React.FC = () => {
  const { tr } = useTranslationLgs();
  const { id } = useParams();

  return (
    <ResponsiveLayout title={tr('LineEdit.pageTitleEdit', 'Úprava linky')} oneOfPermission={[PermissionTypesEnum.PERMISSION_TEMPLATE]}>
      <LineEdit lineId={id} />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(EditLinePage);
